import { render, staticRenderFns } from "./seePeopleFace.vue?vue&type=template&id=2e2e9022&scoped=true&"
import script from "./seePeopleFace.vue?vue&type=script&lang=js&"
export * from "./seePeopleFace.vue?vue&type=script&lang=js&"
import style0 from "./seePeopleFace.vue?vue&type=style&index=0&id=2e2e9022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2e9022",
  null
  
)

export default component.exports